import { Schema } from './ProductCard.schema';

import { Section } from '../../snippets';
import { Button } from '../../snippets/button';
import { Icons } from '../../snippets/Icons';

export function ProductCard({ cms }) {
  const { heading, buttons, smallText, imageDesktop, imageMobile, gradient } =
    cms;
  let gradientClass = 'northern-lights-gradient-v2';
  if (gradient === 'shops') {
    gradientClass = 'shops-gradient';
  } else if (gradient === 'storefronts') {
    gradientClass = 'storefronts-gradient';
  }
  return (
    <Section cms={cms}>
      <div
        className={`${gradientClass} px-5 py-[60px] lg:px-[60px] lg:py-[100px]`}
      >
        <div className="mx-auto flex max-w-8xl flex-col items-start gap-10 overflow-hidden rounded-[40px] bg-grey-900 pt-10 lg:flex-row lg:pt-0">
          <div className="flex flex-col items-start gap-10 px-[30px] lg:w-[600px] lg:flex-shrink-0 lg:py-[80px] lg:pl-[60px] lg:pr-0">
            {heading ? (
              <h2 className="font-aeonik text-4xl font-normal text-primary-light antialiased lg:text-5xl lg:leading-[1.125]">
                {heading}
              </h2>
            ) : null}
            {(buttons && buttons.length > 0) || smallText ? (
              <div className="flex w-full flex-col gap-2.5 lg:gap-3">
                {buttons && buttons.length > 0 ? (
                  <div className="flex w-full flex-col gap-2.5 md:w-auto md:flex-row">
                    {buttons.map((button, index) => (
                      <Button
                        key={`product-card-button-${index}`}
                        link={button.link}
                        icon={button.icon}
                        iconPosition={button.iconPosition}
                      />
                    ))}
                  </div>
                ) : null}
                {smallText ? (
                  <div className="-mr-2.5 flex items-center gap-1 text-grey-400 lg:mr-0">
                    <Icons icon="infoEmpty" />
                    <p className="font-aeonik text-xs antialiased">
                      {smallText}
                    </p>
                  </div>
                ) : null}
              </div>
            ) : null}
          </div>
          <div className="relative flex flex-col self-end pl-[30px] lg:pl-0">
            {(imageDesktop || imageMobile) && (
              <picture>
                {imageDesktop && imageMobile && (
                  <source
                    srcSet={imageDesktop?.src}
                    media="(min-width: 768px)"
                  />
                )}

                <img
                  className="w-full"
                  src={imageMobile?.src || imageDesktop?.src}
                  alt={imageMobile?.alt || imageDesktop?.alt}
                />
              </picture>
            )}
          </div>
        </div>
      </div>
    </Section>
  );
}

ProductCard.displayName = 'ProductCard';
ProductCard.Schema = Schema;
